export default "__VITE_ASSET__CDY0wu5F__"